export default __webpack_public_path__ + "9389832ec781ab18758041ab2acc399b.png";